import React from 'react';
// CSS
import './RightSidebar.css';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
// IMPORTS
import UserDetails from './UserDetails';
import Services from './Services';

import SmallScreenModels from './SmallScreenModels';
// import GiftCard from 'container/components/GiftCard/GiftCard';
// import OfferSlider from 'container/components/OfferSlider/OfferSlider';

function RightSidebar(props) {
  const { loading, token, setSubscriptionModal, setSignUpModal } = props;
  const isOpen = useSelector(state => state.utils.openControls);

  const mobileMenuOpen = useSelector(state => state.utils.openMobileRightMenu);
  const { countryBanner } = useSelector(state => state.location);
  const planData = useSelector(state => state.subscription.planData);

  return (
    <>
      {mobileMenuOpen ? (
        <SmallScreenModels />
      ) : (
        <div
          className={classNames(
            'right__side',
            isOpen ? 'open' : '',
            countryBanner && planData?.plan?.toLowerCase() === 'free'
              ? 'banner'
              : ''
            // planData?.plan?.toLowerCase() === 'free' ? 'banner' : ''
          )}
        >
          <div className='right-top'>
            {/* Services */}
            <Services />
            {/* Marketplace */}
            {/* <Marketplace /> */}
          </div>
          {/* <OfferSlider /> */}
          {/* <GiftCard /> */}
          {/* User details / buttons for signed in or signed up user */}
          <UserDetails
            setSignUpModal={setSignUpModal}
            setSubscriptionModal={setSubscriptionModal}
            loading={loading}
            token={token}
          />
        </div>
      )}
    </>
  );
}

export default RightSidebar;
